import { PayloadAction } from "@reduxjs/toolkit"
import { updateObjectStyle } from "../../../../helpers/object.helpers"
import { ObjectsStateT } from "../../objects.slice"

export type UpdateTickerStylePayload = {
    id: string
    property: string
    value: any
}

export const updateTickerStyleWithoutRestartBaseAction = (
    state: ObjectsStateT,
    action: PayloadAction<UpdateTickerStylePayload>
) => {
    const { id, property, value } = action.payload
    const object = state.value[id]

    if (!object) {
        return
    }

    // Aktualizovat styl bez nastavení updatedAt, aby se nepřegeneroval master timeline
    state.value = {
        ...state.value,
        [id]: {
            ...state.value[id],
            styles: updateObjectStyle(object, property, value) ?? state.value[id].styles,
        },
    }
    // DŮLEŽITÉ: NENASTAVUJEME updatedAt
    // To zajistí, že se ticker nebude restartovat při změnách jako barva, border-radius, atd.
}
